import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Totally Bamboo (b_2ni2ewzx8l, advertiser -5098105546096723776).
// Real numbers from ANALYTICS.ADS.CAMPAIGN_PERIODS (complete months through
// Jun 2026). NEW_AND_RETURNING; reorder value is modeled (see realBrandData.ts).
// Monthly series lives in realBrandData.ts, not in adPerformancePeriod shards.
export const advTotallyBamboo: FaireAdvertiserProfileEntity = {
  token: "adv_totally_bamboo",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "Totally Bamboo",
  brandToken: "b_2ni2ewzx8l",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 34,
  budget: {
    totalBudgetDollars: 13000,
    spendingMode: "AGGRESSIVE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 1078,
    numReorderConversions: 471,
    numTotalConversions: 1549,
    totalAdsSalesDollars: 747660,
    newCustomerAdsSalesDollars: 606831,
    reorderAdsSalesDollars: 140829,
    totalAdsSpendDollars: 109342,
    newCustomerAdsSpendDollars: 95503,
    reorderAdsSpendDollars: 13839,
    newCustomerBestEstimateFirstYearRoas: 6.35,
    reorderRoas: 10.18,
    combinedFirstYearRoas: 6.84,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 10000,
      maxRecommendedBudgetDollars: 14000,
    },
    reorder: {
      minRecommendedBudgetDollars: 3000,
      maxRecommendedBudgetDollars: 5000,
    },
  },
  campaignTokens: ["camp_tb_new", "camp_tb_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-07-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
